import { render, staticRenderFns } from "./InboxMessage.vue?vue&type=template&id=595fe058"
import script from "./InboxMessage.vue?vue&type=script&lang=js"
export * from "./InboxMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports